import React from "react";
import { useTranslation } from "react-i18next";

import { SECTION_IDS } from "@constants/sectionIds";
import { useToolsData } from "@constants/tools";

import ToolsCard from "../../components/ToolsCard/ToolsCard";
import "./Tools.scss";

const Tools = () => {
  const { t } = useTranslation(["landing"]);

  const toolsData = useToolsData();

  return (
    <section id={SECTION_IDS.TOOLS} className="tools">
      <img
        aria-hidden="true"
        src="/images/layouts/finder-lines-1.svg"
        alt=""
        width={2348}
        height={746}
        className="tools-lines-bg tools-lines-bg--desktop"
      />

      <img
        aria-hidden="true"
        src="/images/layouts/finder-lines-2.svg"
        alt=""
        width={2527}
        height={608}
        className="tools-lines-bg tools-lines-bg--mobile"
      />

      <div className="tools-blur-bg" />

      <div className="tools__main">
        <h2 className="green-1">{t("landing:tools.title")}</h2>
        <p className="description">{t("landing:tools.description")}</p>

        <div className="tools-list">
          {toolsData.map(({ id, name, description, recommendedText, image }) => (
            <ToolsCard key={id} name={name} description={description} recommendedText={recommendedText} image={image} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Tools;
